import ChangePwdModal from '@/components/auth/FindPwd/ChangePwdModal';

const ChangePwdPage = () => {
  return <ChangePwdModal />;
};

export default ChangePwdPage;
